import {
	TDC_ABOUT_MODAL_CLOSE,
	TDC_ABOUT_MODAL_SET_SERVICES,
	TDC_ABOUT_MODAL_SHOW,
} from './AboutModal.actions';
import { Versions } from './AboutModal.types';

export const ABOUT_MODAL_REDUCER_KEY = 'AboutModal';

interface AboutModalReducerState {
	aboutModalVisible: boolean;
	services: Versions;
}

export function aboutModalReducer(
	state: AboutModalReducerState = { services: {}, aboutModalVisible: false },
	action: any,
) {
	switch (action.type) {
		case TDC_ABOUT_MODAL_SET_SERVICES:
			return { ...state, services: action.services };
		case TDC_ABOUT_MODAL_SHOW:
			return { ...state, aboutModalVisible: true };
		case TDC_ABOUT_MODAL_CLOSE:
			return { ...state, aboutModalVisible: false };
		default:
			return state;
	}
}
